const getLink = (routePath, link) => {
  if (routePath === '/') {
    return link
  } else {
    return routePath + link
  }
}

export default getLink
